(function() {
    'use strict';

    angular
        .module('app')
        .directive('popupActions', popupActions);

    popupActions.$inject = ['$window'];
    
    function popupActions($window) {
        // Usage:
        //     <popup_actions></popup_actions>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                shown: '=',
                position: '=',
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.$watch(function () {
                return scope.shown;
            }, function (value) {
                           
            })
        }
    }

})();